import { useMutation } from "@tanstack/react-query";

import { replaceMeterCapsule } from "@services/declarations";

export const useReplaceMeterCapsule = (options: Record<string, any> = {}) => {
  return useMutation({
    mutationFn: replaceMeterCapsule,
    ...options,
  });
};
